import { ConsoleLogger } from 'aws-amplify/utils';

// Note: CloudWatch logging in Amplify v6 requires additional setup
// For now, using ConsoleLogger which outputs to browser console
const logger = new ConsoleLogger('stargate.ui', 'INFO');

export default logger;
